import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Popover from '@/shared/components/popover/index.vue';
import store from '@/trust-atcs-app/store';
import { PopoverView } from '@/shared/components/popover/popover';
import { orderBy } from 'lodash';

@Options<RadioButtonBranchList>({
  components: {
    Popover
  }
})
export default class RadioButtonBranchList extends Vue {

  @Prop()
  private question!: any;

  @Watch('selectedOption')
  private onSelectedOptionChanged(): void {
    // reset all selection
    this.question.responses.forEach((r: any, i: number) => {
      this.question.responses[i].answerIsSelected = null;
    });

    // search and select
    this.question.responses.forEach((r: any, i: number) => {
      if (r.value == this.selectedOption) {
        this.question.responses[i].answerIsSelected = true;
      }
    });

    if (this.selectedOption != this.question.subQuestionTriggerValue) {
      this.question.atcsSubQuestions.forEach((r: any, i: number) => {
        this.question.atcsSubQuestions[i].responses[0].answerIsSelected = null;
      });
      this.subQuestionAnswers = this.question.atcsSubQuestions.map((x: any) => x.responses[0].answerIsSelected);
    }

    if (this.selectedOption == this.question.subQuestionTriggerValue && this.question.atcsSubQuestions?.length == 1) {
      this.question.atcsSubQuestions[0].responses[0].answerIsSelected = true;
    }

    this.$emit('validForm', this.validForm());
  }

  private uniqueIdName = null as any;
  private selectedOption = null as any;
  private newWording = '';
  private obj: PopoverView = null as any;
  private subQuestionAnswers: any[] = [];

  created(): void {
    this.uniqueIdName = 'RadioButtonBranchList' + this.question.id;
    this.initField();
    const content = store.getters.getPopovers;
    const popovers = this.question.wording.match(/--{{([^)]+)}}--/)[1];
    this.obj = content.filter((x:any) =>  x.key == popovers)[0];
    this.newWording = this.question.wording.replace('--{{' + popovers + '}}--', '');
  }

  private initField(): void {
    this.question.responses = orderBy(this.question.responses, 'order', 'asc'); 
    const defaultSelection = this.question.responses.filter((x: any) => x.answerIsSelected);
    if (defaultSelection.length > 0) {
      this.selectedOption = defaultSelection[0].value;
    }
    this.subQuestionAnswers = this.question.atcsSubQuestions.map((x: any) => x.responses[0].answerIsSelected);
    this.$emit('validForm', this.validForm());
  }

  private updateSubQuestionAnswer(event: any, i: number): void {
    this.subQuestionAnswers[i] = event.target.checked;
    this.question.atcsSubQuestions[i].responses[0].answerIsSelected = this.subQuestionAnswers[i];
    this.$emit('validForm', this.validForm());
  }

  private validForm(): boolean {
    let valid = false;    
    if (this.selectedOption == this.question.subQuestionTriggerValue) {
      valid = this.question.atcsSubQuestions.filter((x: any) => x.responses[0].answerIsSelected)?.length > 0;
    } else if (this.selectedOption != this.question.subQuestionTriggerValue) {
      valid = this.question.responses.filter((x: any) => x.value == this.selectedOption)?.length > 0;
    }
    return valid;
  }
}
